import { useFundsStore } from "@/Control/Vue/Stores/FundsStore";
import type { MiaPlaza } from "@/Reinforced.Typings";

export function initializeFundsUpdates(feedbackSoundOn: boolean): void {
	// Make PlayFeedbackSound available in js code
	(window as any).PlayFeedbackSound = feedbackSoundOn;
}

/**
 * The latest balance the server has told us about that we have not shown yet.
 * If this is set, something is already waiting for the FundsStore and will show whatever is here once
 * the store appears.
 */
let pendingUpdate: MiaPlaza.SignalR.IFundsUpdate | null = null;

/**
 * Adds the funds handler which updates FundsStore with the actual amount of funds for a child.
 */
export function registerFundsUpdateHandler(connection: signalR.HubConnection): void {
	connection.on("UpdateFunds", async (update: MiaPlaza.SignalR.IFundsUpdate) => {
		const isFirstPendingUpdate = pendingUpdate == null;
		pendingUpdate = update;

		// Only the Header creates the funds store. It may not have rendered yet, and on a page with
		// no header it never will, so the await below can go on forever. Overwriting the pending
		// value instead of starting another wait keeps such a page down to one await in total.
		if (isFirstPendingUpdate) {
			const fundsStore = await useFundsStore();

			const fundsUpdate = pendingUpdate;
			pendingUpdate = null;
			if (fundsUpdate == null) {
				return;
			}

			const fundsAmount = fundsStore.amount;
			if (fundsAmount
				&& fundsAmount < fundsUpdate.Balance
				&& fundsUpdate.PlaySound
				&& (window as any).PlayFeedbackSound) {
				playIncomeSound();
			}

			fundsStore.set(fundsUpdate.Balance);
		}
	});
}

function playIncomeSound() {
	const moneySound = window.soundManager.createSound({ id: "money", url: "/snd/money.mp3" });
	moneySound.play();
}
